import { HOME_PATH } from '../../constants'

export const getTransferURL = (groupId: string) => {
  return `${HOME_PATH}/${groupId}/transfer`
}
